import PropTypes from 'prop-types';

// material-ui
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

// project imports
import AuthCard from './AuthCard';

// assets
import AuthBackground from './AuthBackground';

// ==============================|| AUTHENTICATION - WRAPPER ||============================== //

export default function AuthWrapper({ children }) {
  return (
    <Box sx={{ minHeight: '100vh', position: 'relative', overflow: 'hidden' }}>
      <AuthBackground />
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          minHeight: '100vh',
          position: 'relative',
          zIndex: 1,
          px: { xs: 2, sm: 3 },
          py: { xs: 3, sm: 4 }
        }}
      >
        <Grid size={{xs:12, sx: 4, display: 'flex', justifyContent: 'center' }}>
          <AuthCard sx={{ width: '100%' }}>{children}</AuthCard>
        </Grid>
      </Grid>
    </Box>
  );
}

AuthWrapper.propTypes = { children: PropTypes.node };
